module.exports = __webpack_public_path__ + "static/media/log-in.015ad99a.jpg";